import { KeyboardArrowLeft } from '@mui/icons-material';
import { Grid, Container, Breakpoint } from '@mui/material';

import { LinkButton } from 'components/LinkButton';
import { layout, colors } from 'config';

import { Sticky } from './styledComponents';

export interface FormGridProps {
  path: string;
  label: string;
  maxWidth?: Breakpoint;
}
export const FormGrid: React.FC<FormGridProps> = (props) => {
  const { children, path, label, maxWidth } = props;
  return (
    <Grid container spacing={2}>
      <Grid item xs={1}>
        <Sticky>
          <LinkButton
            to={path}
            startIcon={<KeyboardArrowLeft color='inherit' />}
            style={{ textAlign: 'left', lineHeight: 1.2, marginTop: '40px' }}
          >
            {label}
          </LinkButton>
        </Sticky>
      </Grid>
      <Grid item xs={10}>
        <Container
          maxWidth={maxWidth ?? 'lg'}
          sx={{
            padding: '40px 50px',
            borderRadius: 1,
            background: 'white',
            outline: `${layout.borderRadius.s} solid ${colors.lightGray}`,
            marginTop: 3,
            marginBottom: 3,
          }}
        >
          {children}
        </Container>
      </Grid>
      <Grid item xs={1}>
        <div />
      </Grid>
    </Grid>
  );
};
